import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'

const state = {
    tab: 'personalia',
    gender: 'd',
    age: 0,
    noofPhotos: 0,
    formData: {}
}

const store = new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
})

export default store


